import { render } from "./AppSidebarExpand.vue?vue&type=template&id=bef56540"
const script = {}

import exportComponent from "D:\\online\\paramedicsuz_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__